// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/*
Integrar api v2 progresivamente
*/

export const environment = {
  production: false,
  //apiUrl: 'http://localhost:8080/api/v1',
  //apiUrlV2: 'http://localhost:8080/api/v2',
  //apiUrl: 'https://api.saftelmah.com/api/v1'
  //apiUrl: "http://127.0.0.1:8080/api/v1",
  apiUrl: 'https://dev.api.saftelmah.com/api/v1',
  apiUrlV2: 'https://dev.api.saftelmah.com/api/v2'
};

/*

 * In development mode, to ignore zone related error stack frames such as
 * `zone.run` , `zoneDelegate.invokeTa
 * sk` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
